// @flow

import React from 'react';

import AbstractPollsPane from '../AbstractPollsPane';
import type { AbstractProps } from '../AbstractPollsPane';
import { getLocalParticipant, isParticipantModerator } from '../../../base/participants';
import PollsList from './PollsList';

import { translate } from '../../../base/i18n';
import { connect } from '../../../base/redux';

import { PollCreate } from '.';

const PollsPane = (props: AbstractProps) => {
    console.log(props)

    const { createMode, onCreate, setCreateMode, t, _isModerator } = props;

    return createMode
        ? <PollCreate setCreateMode = { setCreateMode } />
        : <div className = 'polls-pane-content'>
            <div className = { 'poll-container' } >
                <PollsList />
            </div>
            { _isModerator && <div className = { 'poll-footer' }>
                <button
                    aria-label = { t('polls.create.create') }
                    className = { 'poll-primary-button' }
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick = { onCreate } >
                    <span>{t('polls.create.create')}</span>
                </button>
            </div>
            }
        </div>;
};


/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code } component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
 function _mapStateToProps(state) {
    const _localParticipant = getLocalParticipant(state);
    const isModerator = isParticipantModerator(_localParticipant);


    return {
        _isModerator: isModerator
    };
}

/*
 * We apply AbstractPollsPane to fill in the AbstractProps common
 * to both the web and native implementations.
 */
// eslint-disable-next-line new-cap
export default AbstractPollsPane(translate(connect(_mapStateToProps)(PollsPane)));
